import { Home } from 'lucide-react';
import { Pill } from '@/shared/components';
import type { UserAccessPropertyResponse, UserAccessPropertySourceResponse } from '@/shared/api';

const SOURCE_META: Record<
  UserAccessPropertySourceResponse['kind'],
  { label: string; variant: 'default' | 'live' | 'on' }
> = {
  direct: { label: 'Direkte Freigabe', variant: 'default' },
  company: { label: 'Firmenfreigabe', variant: 'live' },
  team: { label: 'Teamfreigabe', variant: 'on' },
};

export function UserAccessPropertyScopeList({
  properties,
}: {
  properties: UserAccessPropertyResponse[];
}) {
  return (
    <ul className="border-line/50 divide-line/50 overflow-hidden rounded-md border">
      {properties.map((property) => (
        <li
          key={property.id}
          className="flex min-w-0 flex-col gap-2 px-3 py-2.5 sm:flex-row sm:items-center sm:gap-3"
        >
          <div className="flex min-w-0 items-center gap-3">
            <Home size={16} className="text-ink-faint shrink-0" aria-hidden />
            <span className="text-ink min-w-0 flex-1 truncate text-sm">{property.name}</span>
          </div>
          <span className="flex min-w-0 flex-wrap gap-1 sm:ml-auto sm:justify-end">
            {property.sources.map((source) => {
              const meta = SOURCE_META[source.kind];
              return (
                <Pill key={source.kind} variant={meta.variant} size="sm">
                  {meta.label}
                </Pill>
              );
            })}
          </span>
        </li>
      ))}
    </ul>
  );
}
